import { enableProdMode, APP_INITIALIZER, importProvidersFrom } from '@angular/core';

import { Environment } from './environments/environment';
import { AppComponent } from './modules/app/app-component/app.component';
import { TableModule } from 'primeng/table';
import { AppRoutes } from './modules/app/app.routes';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { BadgeModule } from 'primeng/badge';
import { TooltipModule } from 'primeng/tooltip';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { MessageService, ConfirmationService } from 'primeng/api';
import { HTTP_INTERCEPTORS, HttpClient, withInterceptorsFromDi, provideHttpClient } from '@angular/common/http';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { Menu } from './modules/app/menu/menu';
import { AppMenu, HttpInterceptor, BASE_BACKEND_URL, GraphQLClient } from '@biorec/common';
import { KeycloakService, KeycloakBearerInterceptor, KeycloakAngularModule } from 'keycloak-angular';

/// <reference types="@angular/localize" />

if (Environment.production) {
	enableProdMode();
}
bootstrapApplication(AppComponent, {
	providers: [
		importProvidersFrom(
			BrowserModule,
			TooltipModule,
			BadgeModule,
			ToastModule,
			ButtonModule,
			ConfirmDialogModule,
			AppRoutes,
			KeycloakAngularModule,
			TableModule
		),
		{
			provide: APP_INITIALIZER,
			deps: [KeycloakService],
			useFactory: (kcs: KeycloakService) => () => kcs.init(Environment.keycloakOptions),
			multi: true
		},
		{ provide: AppMenu, useClass: Menu },
		{ provide: LocationStrategy, useClass: PathLocationStrategy },
		{ provide: HTTP_INTERCEPTORS, useClass: KeycloakBearerInterceptor, multi: true },
		{ provide: HTTP_INTERCEPTORS, useClass: HttpInterceptor, multi: true },
		{ provide: BASE_BACKEND_URL, useValue: Environment.backendUrl },
		MessageService, ConfirmationService, HttpClient, GraphQLClient,
		provideHttpClient(withInterceptorsFromDi()),
		provideAnimationsAsync(),
	]
})
	.catch(e => {
		if (e.error == "access_denied") {
			// dummy force redirection to login if access denied for some reason
			location.reload();
			return;
		}
		console.error(e);
	});
